exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".margin[data-v-614c78d2] {\n  margin: 32px 32px 32px 32px;\n}\n", ""]);

// exports
